import React from "react";
import nextId from "react-id-generator";
import { useHistory } from "react-router";
import "./dashboard-footer.style.scss";
export default function DashboardFooter() {
  const history = useHistory();
  const handleClick = (obj) => {
    switch (obj.id) {
      case "advice":
        break;
      case "browseJobs":
        window.scroll({ top: 0 });
        history.push("/user/list/all");
        break;
      case "browseCompanies":
        window.scroll({ top: 0 });
        history.push("/institute/job");
        break;
      case "salaries":
        break;
      case "aEvents":
        break;
      case "work":
        break;
      case "country":
        break;
      case "about":
        history.push("/about");

        break;
      case "help":
        window.scroll({ top: 0 });
        history.push("/help");
        break;
      case "access":
        break;
      case "pp":
        window.scroll({ top: 0 });
        history.push("/privacy-policy");
        break;
      case "cookie":
        break;
      case "privacy":
        window.scroll({ top: 0 });
        history.push("/privacy-policy");
        break;
      case "terms":
        window.scroll({ top: 0 });
        history.push("/terms-and-condition");
        break;

      default:
        break;
    }
  };
  return (
    <footer className="dashboard-footer">
      <p>
        {listF.map((obj, num) => (
          <div key={obj.keyId} style={{display: "inline"}}>
            {!num ? "" : " - "}
            <span onClick={() => handleClick(obj)} key={obj.keyId}>
              {obj.name}
            </span>
          </div>
        ))}
      </p>
      <p>
        <span>© 2021 AcadsHR</span>
        {listOther.map((obj) => (
          <span onClick={() => handleClick(obj)} key={obj.keyId}>
            {obj.name}
          </span>
        ))}
      </p>
    </footer>
  );
}
const listF = [
  { keyId: nextId(), name: "Career Advice", id: "advice" },
  { keyId: nextId(), name: "Browse Jobs", id: "browseJobs" },
  { keyId: nextId(), name: "Browse Companies", id: "browseCompanies" },
  { keyId: nextId(), name: "Salaries", id: "salaries" },
  { keyId: nextId(), name: "AcadsHR Events ", id: "aEvents" },
  { keyId: nextId(), name: "Work at Indeed", id: "work" },
  { keyId: nextId(), name: "Countries", id: "country" },
  { keyId: nextId(), name: "About", id: "about" },
  { keyId: nextId(), name: "Help Center", id: "help" },
];
const listOther = [
  { keyId: nextId(), name: "Accessibility at Indeed", id: "access" },
  { keyId: nextId(), name: "Privacy policy", id: "pp" },
  { keyId: nextId(), name: "Cookies", id: "cookie" },
  { keyId: nextId(), name: "Privacy", id: "privacy" },
  { keyId: nextId(), name: "Terms", id: "terms" },
];
